// import SearchIcon from "assets/icons/SearchIcon";
// import { SearchInput } from "components/common/Input";
import Label from "components/common/Label";
import TestCard from "./TestCard";
import Carousel from "components/common/Carousel";
import SuggestionsBlock from "components/SuggestionsBlock";
// import React, { useState } from "react";
// import OutsideClickHandler from "components/common/OutsideClickHandler";
import {
  useSolvedQuestionnaires,
  useStartQuiz,
  useUnsolvedQuestionnaires,
} from "api/questionnaire";
import PersonalAINotFound from "../PersonalAINotFound";
import Loader from "components/Loader";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
// import FilterMenu from "./FilterMenu";


export default function Quizzes() {
  // const [selectedFilter, setSelectedFilter] = useState("popularity");
  // const [openDropdown, setOpenDropdown] = useState(false);
  const { data: questionnaires, isLoading: loadingQuestionnaires } =
    useUnsolvedQuestionnaires();
  const { data: recentlyViewed, isLoading: loadingRecentlyViewed } =
    useSolvedQuestionnaires();
  const { mutate: startQuiz, isPending: startingQuiz } = useStartQuiz();
  const navigate = useNavigate();

  if (loadingQuestionnaires || loadingRecentlyViewed) {
    return <Loader open />;
  }

  return (
    <>
      {recentlyViewed?.length === 0 && questionnaires?.length === 0 && (
        <PersonalAINotFound message="No Quiz to show yet" />
      )}
      <>
          <Loader open={startingQuiz} type="block" />
        {/* <div className="my-16 flex items-center justify-start md:justify-between max-w-[min(100vw,768px)]">
          <SearchInput
            placeholder={t('searchForATest')}
            icon={<SearchIcon fill="#F29423" />}
            inputContainerClassName={
              "border-[#5A70E84F] !rounded-full w-3/4 md:w-full max-w-[min(80vw,360px)] py-3"
            }
          />
          <div className="relative mx-5 md:hidden">
            <button
              className="text-black text-sm cursor-pointer"
              onClick={() => setOpenDropdown(!openDropdown)}
            >
              {t('sortBy')}
            </button>
            {openDropdown && (
              <OutsideClickHandler
                onClickOutside={() => setOpenDropdown(false)}
                className="absolute md:hidden rounded-xl shadow-theme top-full -right-4 py-2 mt-1 min-w-[160px] bg-white"
              >
                <FilterMenu
                  selectedFilter={selectedFilter}
                  setSelectedFilter={setSelectedFilter}
                />
              </OutsideClickHandler>
            )}
          </div>
          <div className="hidden md:block">
            <FilterMenu
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
            />
          </div>
        </div> */}
        <div className="mt-8"></div>
        {recentlyViewed?.length > 0 ? (
          <div>
            <Label>{t('quizzesRecentlyViewed')}</Label>
            <Carousel
              options={{
                spaceBetween: 40,
                loop: false,
              }}
              items={recentlyViewed ?? []}
              renderItem={(item) => {
                let props = {
                  ...item,
                  ...item.questionnaire,
                  showProgress: true,
                  onClick: () => navigate(`/personal-ai/quiz/${item._id}`),
                };
                return <TestCard {...props} />;
              }}
            />
          </div>
        ) : (
          ""
        )}
        {questionnaires?.length > 0 ? (
          <div>
            <Label>{t('cognitive')}</Label>
            <Carousel
              options={{
                spaceBetween: 40,
              }}
              items={questionnaires ?? []}
              renderItem={(item) => (
                <TestCard {...item} onClick={() => startQuiz(item._id)} />
              )}
            />
          </div>
        ) : (
          ""
        )}
      </>
      {/*
      <div>
        <Label>{translation.careerOriented[language]}</Label>
        <Carousel
          options={{
            spaceBetween: 40,
          }}
          items={
            translation.testList.map((item, idx) => ({
              ...item,
              image: require(`assets/images/persona-ai/test-${idx + 1}.png`),
            })) ?? []
          }
          renderItem={(item) => <TestCard {...item} />}
        />
      </div>
      <div>
        <Label>{translation.Personality[language]}</Label>
        <Carousel
          options={{
            spaceBetween: 40,
          }}
          items={
            translation.testList.map((item, idx) => ({
              ...item,
              image: require(`assets/images/persona-ai/test-${idx + 1}.png`),
            })) ?? []
          }
          renderItem={(item) => <TestCard {...item} />}
        />
      </div>
      */}
      <div>
        <SuggestionsBlock />
      </div>
    </>
  );
}
